import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import './OwnerBadge.css';

const OWNER_BADGE_PREF_KEY = 'aot_admin_show_owners_v1';

const readShowOwnersPref = () => {
  try {
    const raw = localStorage.getItem(OWNER_BADGE_PREF_KEY);
    if (raw === null) {
      return true;
    }
    return raw === '1';
  } catch (_) {
    return true;
  }
};

const OwnerBadge = ({ email }) => {
  const { user } = useAuth();
  const [showOwners, setShowOwners] = useState(readShowOwnersPref);

  useEffect(() => {
    const handlePref = () => setShowOwners(readShowOwnersPref());
    window.addEventListener('aot-owner-badge-pref', handlePref);
    window.addEventListener('storage', handlePref);
    return () => {
      window.removeEventListener('aot-owner-badge-pref', handlePref);
      window.removeEventListener('storage', handlePref);
    };
  }, []);

  if (!user?.is_staff) {
    return null;
  }
  if (!showOwners) {
    return null;
  }
  if (!email) {
    return null;
  }
  return <span className="owner-badge">owner:{email}</span>;
};

export default OwnerBadge;
